import { Box, IconButton, Stack } from "@mui/material";
import { Minus, Plus } from "@phosphor-icons/react";
import React, { useEffect } from "react";
import { useState } from "react";

function ProductQuantityButtons({ updatePrice, miniQty, maxQty }) {
  const [quantity, setQuantity] = useState(miniQty || 1);

  useEffect(() => {
    quantity > 0 && updatePrice(quantity);
  }, [quantity]);
  useEffect(() => {
    miniQty > 0 && setQuantity(miniQty);
  }, [miniQty]);
  const increaseQuantity = () => {
    setQuantity((prev) => {
      if (maxQty && prev >= maxQty) return prev; // stop at max
      return prev + 1;
    });
  };
  const decreaseQuantity = () =>
    setQuantity((prev) => (prev > 1 ? prev - 1 : prev));
  return (
    <Stack direction="row" spacing={2}>
      <IconButton
        disabled={quantity <= 1 ? true : false}
        onClick={decreaseQuantity}
        sx={{
          backgroundColor: "#F9F8F8",
          "&:hover": { backgroundColor: "#e0e0e0" },
          width: 40,
          height: 40,
          borderRadius: "4px",
        }}
      >
        <Minus size={24} color="var(--neutral-600)" />
      </IconButton>
      <Box
        sx={{
          width: 40,
          height: 40,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#F9F8F8",
          fontWeight: 600,
          borderRadius: "4px",
        }}
      >
        {quantity}
      </Box>
      <IconButton
        disabled={maxQty ? quantity >= maxQty : false}
        onClick={increaseQuantity}
        sx={{
          backgroundColor: "#F9F8F8",
          "&:hover": { backgroundColor: "#e0e0e0" },
          width: 40,
          height: 40,
          borderRadius: "4px",
        }}
      >
        <Plus size={24} color="var(--neutral-600)" />
      </IconButton>
    </Stack>
  );
}

export default ProductQuantityButtons;
